import { render, staticRenderFns } from "./PneuBorracha.vue?vue&type=template&id=113076aa&"
import script from "./PneuBorracha.vue?vue&type=script&lang=js&"
export * from "./PneuBorracha.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PneuBorracha.vue?vue&type=style&index=1&id=113076aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports